import React, { useContext } from 'react';
import { FaArchive } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from '../../../../ThemeContext';

const BackupComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);
  const isActive = location.pathname === '/app/backups';

  const showBackups = () => {
    navigate('/app/backups');
  };

  return (
    <div onClick={showBackups} title="Kopie zapasowe pieśni" role="button" tabIndex={0} aria-label="Kopie zapasowe pieśni"
         aria-current={isActive ? 'page' : undefined}
         onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); showBackups(); } }} style={{
      cursor: 'pointer',
      borderRadius: '30%',
      padding: '5px',
      backgroundColor: isActive ? 'var(--active-item-bg-color)' : 'transparent'
    }}>
      <FaArchive style={{
        color: isActive ? 'var(--active-item-text-color)' : (theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-color)')
      }} />
    </div>
  );
};

export default BackupComponent;
